module.exports = __webpack_public_path__ + "img/cun_en.073fb586.jpg";